module.exports = __webpack_public_path__ + "first-100-paper.jpg?04a14ab5498beaeb77165cd15a4e7a47";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-100-paper.jpg
// module id = 418
// module chunks = 0